import React from 'react';
import { ViewProps } from 'react-native';
import styled from 'styled-components/native';
import { getElevationStyle } from '@theme/aiaTheme';

interface CardProps extends ViewProps {
  variant?: 'elevated' | 'outlined' | 'flat';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

const StyledCard = styled.View<CardProps>`
  background-color: ${({ theme, variant = 'elevated' }) =>
    variant === 'flat' ? theme.colors.surfaceAlt : theme.colors.surface};
  border-radius: ${({ theme }) => theme.radius.md}px;
  padding: ${({ theme, padding = 'md' }) => {
    switch (padding) {
      case 'none':
        return 0;
      case 'sm':
        return theme.spacing.md;
      case 'lg':
        return theme.spacing.xl;
      default:
        return theme.spacing.base;
    }
  }}px;
  border-width: ${({ variant = 'elevated' }) => (variant === 'outlined' ? 1 : 0)}px;
  border-color: ${({ theme }) => theme.colors.border};
  ${({ theme, variant = 'elevated' }) =>
    variant === 'elevated' ? getElevationStyle(theme.elevation.md) : ''};
`;

export const Card: React.FC<CardProps> = ({ children, ...props }) => (
  <StyledCard {...props}>{children}</StyledCard>
);
